import angular from 'angular';
import _ from 'lodash';
import moment from 'moment-timezone';

import { documentTypes } from 'src/app/core/constants';
import { keyBy } from 'src/app/shared/utils';

import {
    EscPosEncoder
} from 'src/app/features/printers/drivers';

angular.module('printers').controller('PrintersDetailCtrl', PrintersDetailCtrl);

PrintersDetailCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$filter",
    "$translate",
    "printer",
    "printers",
    "items",
    "confirmDialog",
    "alertDialog",
    "entityManager",
    "categories",
    "FiscalPrinters",
    "environmentInfo",
    "dgfeResult",
    "options",
    "departments",
    "vat",
    "rooms",
    "paymentMethods",
    "printerErrorFiscal",
    "dailyClosingDialog",
    "genericListDialog"
];

function PrintersDetailCtrl(
    $scope,
    $rootScope,
    $state,
    $filter,
    $translate,
    printer,
    printers,
    items,
    confirmDialog,
    alertDialog,
    entityManager,
    categories,
    FiscalPrinters,
    environmentInfo,
    dgfeResult,
    options,
    departments,
    vat,
    rooms,
    paymentMethods,
    printerErrorFiscal,
    dailyClosingDialog,
    genericListDialog
) {
    const getDocumentTypeName = (type) => {
        switch(type.id) {
            case "fiscal_receipt":
                return printer.type === 'rt' ? $translate.instant('PRINTERS.DETAIL.COMMERCIAL_DOC') : $translate.instant('PRINTERS.DETAIL.FISCAL_RECEIPT');
            case "receipt_invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_RECEIPT_INVOICE');
            case "invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_INVOICE');
            case "e_invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_E_INVOICE');
            case "summary_e_nrc":
                return $translate.instant('PRINTERS.DETAIL.PRINT_SUMMARY_E_NRC');
            case "summary_e_rc":
                return $translate.instant('PRINTERS.DETAIL.PRINT_SUMMARY_E_RC');
            case "summary_invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_SUMMARY_INVOICE');
            case "shipping_invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_SHIPPING_INVOICE');
            case "receipt": case "generic_receipt":
                return $translate.instant('PRINTERS.DETAIL.PRINT_RECEIPT');
            case "generic_invoice":
                return $translate.instant('PRINTERS.DETAIL.PRINT_GENERIC_INVOICE');
            case "generic_document":
                return $translate.instant('PRINTERS.DETAIL.PRINT_GENERIC_DOCUMENT');
            default: return '';
        }
    };

    Object.assign($scope, {
        cash: {},
        categories: categories,
        cashregisters: [],
        codepageMappings: [{ name: 'Raster', value: 'raster' }, ...EscPosEncoder.getAvailableCodepageMappings()],
        departments: departments,
        dgfe: {},
        documentTypes: _(documentTypes).filter((docType) => docType.printers.includes(printer.type)).map((docType) => ({ id: docType.id, check: docType.check, name: getDocumentTypeName(docType) })).value(),
        fiscalMem: {},
        headerLineNumbers: _.range(1, 14),
        invoiceFooterLineNumbers: _.range(1, 7),
        items: items,
        isValid: () => $scope.settingsForm?.$valid || false,
        options: options,
        otherPrinters: [],
        paymentMethods: paymentMethods,
        printer: structuredClone(printer),
        rooms: [],
        vat: vat,
        fontSizes: [{
            label: $translate.instant('PRINTERS.DETAIL.SMALL'),
            value: 0
        }, {
            label: $translate.instant('PRINTERS.DETAIL.MEDIUM'),
            value: 16
        }, {
            label: $translate.instant('PRINTERS.DETAIL.BIG'),
            value: 17
        }],
        headerSizes: [{
            label: $translate.instant('PRINTERS.DETAIL.DISABLED'),
            value: -1
        }, {
            label: $translate.instant('PRINTERS.DETAIL.SMALL'),
            value: 0
        }, {
            label: $translate.instant('PRINTERS.DETAIL.MEDIUM'),
            value: 16
        }, {
            label: $translate.instant('PRINTERS.DETAIL.BIG'),
            value: 17
        }],
        lineSpacings: [{
            label: $translate.instant('PRINTERS.DETAIL.NONE'),
            value: 0
        }, {
            label: $translate.instant('PRINTERS.DETAIL.ONE_ROW'),
            value: 80
        }],
        itemSpacings: [{
            label: $translate.instant('PRINTERS.DETAIL.NONE'),
            value: 0
        }, {
            label: $translate.instant('PRINTERS.DETAIL.ONE_ROW'),
            value: 1
        }],
        itemsAligns: [{
            label: $translate.instant('PRINTERS.DETAIL.LEFT'),
            value: 'left'
        }, {
            label: $translate.instant('PRINTERS.DETAIL.CENTER'),
            value: 'center'
        }, {
            label: $translate.instant('PRINTERS.DETAIL.RIGHT'),
            value: 'right'
        }],
        itemsGroupBy: [{
            label: $translate.instant('PRINTERS.DETAIL.EXIT'),
            value: 'exit'
        }, {
            label: $translate.instant('PRINTERS.DETAIL.CATEGORY'),
            value: 'category_id'
        },{
            label: $translate.instant('PRINTERS.DETAIL.EXIT_AND_CATEGORY'),
            value: 'exit_and_category'
        }]
    });

    const defaultConfigs = {
        nonfiscal: {
            add_prices_to_order: false,
            codepage_mapping: 'epson',
            footer_printer_categories: -1,
            footer_order_number: -1,
            footer_operator_name: -1,
            footer_print_type: -1,
            footer_date: -1,
            footer_time: -1,
            footer_room_name: -1,
            footer_table_name: -1,
            footer_covers: -1,
            footer_delivery_info: -1,
            footer_order_name: -1,
            footer_customer_info: -1,
            footer_order_notes: -1,
            footer_total_pieces: -1,
            footer_final_amount: -1,
            header_printer_categories: -1,
            header_order_number: 16,
            header_operator_name: 16,
            header_print_type: 16,
            header_date: 16,
            header_time: 16,
            header_room_name: 16,
            header_table_name: 16,
            header_covers: 16,
            header_delivery_info: 16,
            header_order_name: 0,
            header_customer_info: 16,
            header_order_notes: 0,
            header_total_pieces: -1,
            header_final_amount: -1,
            item_font_size: 16,
            item_spacing: 1,
            item_hide_border: false,
            item_hide_brackets: false,
            items_align: 'center',
            items_group_by: 'exit',
            other_printers_font_size: 0,
            line_spacing: 80,
            split_orders_by_exit: false,
            variation_font_size: 16,
        },
        receipt: {
            split_stubs_by_category: false,
            print_other_categories: false,
            codepage_mapping: 'epson'
        },
        fiscal: {
            split_stubs_by_category: false,
            print_other_categories: false,
        },
        rt: {
            split_stubs_by_category: false,
            print_other_categories: false,
        }
    };

    const parsePrinterCategories = () => {
        const categoriesNew = categories.sort((a, b) => a.index - b.index).map((c) => ({
            id: c.id,
            name: c.name,
            toPrint: false
        }));

        const categoriesNewById = keyBy(categoriesNew, (c) => c.id);

        for(const category of printer.categories || []) {
            if(categoriesNewById[category.id]) {
                categoriesNewById[category.id].toPrint = true;
            }
        }

        Object.assign($scope.printer, {
            categories: categoriesNew,
            _allCategories: categoriesNew.every((c) => c.toPrint),
        });
    };

    const parsePrinterConfiguration = () => {
        parsePrinterCategories();

        //Load existing config
        $scope.printerConfiguration = Object.assign({}, defaultConfigs[$scope.printer.type]);

        if ($scope.printer.configuration) {
            try {
                const configuration = JSON.parse($scope.printer.configuration);

                Object.assign($scope.printerConfiguration, configuration);
            } catch (e) {
                console.log(e);
            }
        }

        if (['nonfiscal', 'receipt'].includes($scope.printer.type)) {
            parseNonFiscalConfiguration();
        }
    };

    const parseNonFiscalConfiguration = () => {
        //Initialize config structures
        $scope.rooms = rooms.map((p) => ({ id: p.id, name: p.name, _enabled: false }));

        $scope.rooms.unshift(
            { id: 'take_away', name: $translate.instant('PRINTERS.DETAIL.TAKE_AWAY'), _enabled: false },
            { id: 'delivery', name: $translate.instant('PRINTERS.DETAIL.DELIVERY'), _enabled: false },
            { id: 'no_rooms', name: $translate.instant('PRINTERS.DETAIL.NO_ROOMS'), _enabled: false } 
        );

        $scope.cashregisters = printers
            .filter((p) => (['fiscal', 'rt', 'receipt'].includes(p.type) && p.id !== printer.id))
            .map((p) => ({ id: p.id, name: p.name, _enabled: false }));

        $scope.otherPrinters = printers
            .filter((p) => (p.type === 'nonfiscal' && p.id !== printer.id))
            .map((p) => ({ id: p.id, name: p.name, _enabled: false }));

        //Create dictionaries        
        const roomsById = keyBy($scope.rooms, (p) => p.id);
        const cashregistersById = keyBy($scope.cashregisters, (c) => c.id);
        const otherPrintersById = keyBy($scope.otherPrinters, (p) => p.id);

        //Parse printer configuration
        const nonfiscalConfig = $scope.printerConfiguration;

        //Migration for other printers
        const otherPrinters = nonfiscalConfig.other_printers || [];

        if(otherPrinters.length > 0) {
            switch(typeof otherPrinters[0]) {
                case 'number': //Old format
                    for(const printerid of otherPrinters) {
                        if(otherPrintersById[printerid]) {
                            otherPrintersById[printerid]._enabled = true;
                        }
                    }
                break;
                case 'object': //New format
                    for(const printer of otherPrinters) {
                        if(otherPrintersById[printer.id]) {
                            otherPrintersById[printer.id]._enabled = true;
                            otherPrintersById[printer.id].inline = printer.inline;
                        }
                    }
                break;
            }
        }

        for(const roomId of nonfiscalConfig.rooms || []) {
            if(roomsById[roomId]) {
                roomsById[roomId]._enabled = true;
            }
        }

        for(const cashregisterId of nonfiscalConfig.cashregisters || []) {
            if(cashregistersById[cashregisterId]) {
                cashregistersById[cashregisterId]._enabled = true;
            }
        }

        Object.assign($scope.printer, {
            _enableAllCashregisters: $scope.cashregisters.every((c) => c._enabled),
            _enableAllOtherPrinters: $scope.otherPrinters.every((c) => c._enabled),
            _enableAllRooms: $scope.rooms.every((c) => c._enabled)
        });
    };

    $scope.copyPrinterSettings = async () => {
        const orderPrinters = printers.filter(p => p.type === 'nonfiscal' && p.id !== $scope.printer.id);

        const sourcePrinter = await genericListDialog.openDialog({
            data: {
                title: { label: 'PRINTERS.DETAIL.COPY_PRINTER_SELECT' },
                list: orderPrinters.map((p) => ({ name: p.name, value: p, isSelected: false }))
            }
        });

        if(!sourcePrinter) {
            return;
        }

        let printerConfig;

        try {
            printerConfig = JSON.parse(sourcePrinter.configuration || '{}');
        } catch(err) {
            printerConfig = {};
        }

        const { cashregisters, other_printers, rooms, ...configToCopy } = printerConfig;

        Object.assign($scope.printer, {
            columns: sourcePrinter.columns,
            configuration: JSON.stringify(configToCopy),
            enable_buzzer: sourcePrinter.enable_buzzer,
            top_space: sourcePrinter.top_space,
            bottom_space: sourcePrinter.bottom_space
        });

        parsePrinterConfiguration();
    };

    $scope.savePrinter = async () => {
        const proceed = await confirmDialog.show($translate.instant('PRINTERS.DETAIL.WANT_TO_SAVE'));

        if (!proceed) {
            return;
        }
        
        $scope.$parent.showPrintersLoader();

        const printerToSave = preparePrinterForSave();

        await entityManager.printers.putOneOnline(printerToSave);

        $state.reload("app.printers");
    };

    $scope.configure = async () => {
        const proceed = await confirmDialog.show($translate.instant('PRINTERS.DETAIL.WANT_TO_CONFIG'));

        if (!proceed) {
            return;
        }

        try {
            $scope.configuringPrinter = true;
            showPrinterOperationLoader();

            const printer = preparePrinterForSave();

            await FiscalPrinters.configurePrinter(printer, options);
            alertDialog.show($translate.instant('PRINTERS.DETAIL.CONFIGURATION_COMPLETED'));
        } catch (error) {
            printerErrorFiscal.show(error, { printerId: $scope.printer.id });
            //new modal is ready to replace the old one
        } finally {
            hidePrinterOperationLoader();
            $scope.configuringPrinter = false;
        }
    };

    const allSelector = (targetArr, flag, value) => {
        for (const el of targetArr) {
            el[flag] = value;
        }
    };

    $scope.selectAllCategories = () => allSelector($scope.printer.categories, 'toPrint', $scope.printer._allCategories);
    $scope.selectAllOtherPrinters = () => allSelector($scope.otherPrinters, '_enabled', $scope.printer._enableAllOtherPrinters);
    $scope.selectAllRooms = () => allSelector($scope.rooms, '_enabled', $scope.printer._enableAllRooms);
    $scope.selectAllCashregisters = () => allSelector($scope.cashregisters, '_enabled', $scope.printer._enableAllCashregisters);

    $scope.deletePrinter = async () => {
        let proceed = await confirmDialog.show($translate.instant('PRINTERS.DETAIL.WANT_TO_REMOVE'));

        if (proceed) {
            $scope.$parent.showPrintersLoader();

            try {
                await entityManager.printers.deleteOneOnline($scope.printer.id, true);
                $scope.$parent.goTo('printers.general', null, true);
            } catch (err) {
                $scope.$parent.hidePrintersLoader();
            }
        }
    };

    const showPrinterOperationLoader = () => $rootScope.$broadcast("loader:changeStatus", "operationWithPrinterLoader", { enabled: true });
    const hidePrinterOperationLoader = () => $rootScope.$broadcast("loader:changeStatus", "operationWithPrinterLoader", { enabled: false });

    const executeFiscalOperation = async ({ confirmMessage, operationFn, successMessage, printerId = $scope.printer.id }) => {
        if (confirmMessage) {
            const proceed = await confirmDialog.show(confirmMessage);

            if (!proceed) {
                return;
            }
        }

        showPrinterOperationLoader();

        try {
            const result = await operationFn();

            if (successMessage) {
                alertDialog.show(successMessage);
            }

            return result;
        } catch (error) {
            printerErrorFiscal.show(error, { printerId });
        } finally {
            hidePrinterOperationLoader();
        }
    };

    $scope.dailyRead = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_READ_DAILY'),
        operationFn: () => FiscalPrinters.dailyRead({ printer: { id: $scope.printer.id } }),
        successMessage: $translate.instant('PRINTERS.DETAIL.DAILY_READ_COMPLETED')
    });

    $scope.dailyClosing = async () => {
        await dailyClosingDialog.openDialog({ data: structuredClone($scope.printer) });
    };

    $scope.deposit = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_DEPOSIT'),
        operationFn: async () => {
            await FiscalPrinters.deposit({ printer: { id: $scope.printer.id } }, $scope.cash.amount);
            Object.assign($scope.cash, { type: false, amount: null });
        },
        successMessage: $translate.instant('PRINTERS.DETAIL.DEPOSIT_COMPLETED')
    });

    $scope.withdrawal = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_WITHDRAWAL'),
        operationFn: async () => {
            await FiscalPrinters.withdrawal({ printer: { id: $scope.printer.id } }, $scope.cash.amount);
            Object.assign($scope.cash, { type: false, amount: null });
        },
        successMessage: $translate.instant('PRINTERS.DETAIL.WITHDRAWAL_COMPLETED')
    });

    $scope.printFiscalMemory = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_PRINT'),
        operationFn: () => FiscalPrinters.printFiscalMemory({ printer: { id: $scope.printer.id } }),
        successMessage: $translate.instant('PRINTERS.DETAIL.PRINT_COMPLETED')
    });

    $scope.printFiscalMemoryBetween = async () => {
        if ($scope.fiscalMem.from > $scope.fiscalMem.to) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.DATE_ERROR'));
            return;
        }

        await executeFiscalOperation({
            confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_PRINT'),
            operationFn: () => FiscalPrinters.printFiscalMemoryBetween(
                { printer: { id: $scope.printer.id } },
                $scope.fiscalMem.corrispettivi || false,
                convertDateToDDMMYY($scope.fiscalMem.from),
                convertDateToDDMMYY($scope.fiscalMem.to)
            ),
            successMessage: $translate.instant('PRINTERS.DETAIL.PRINT_COMPLETED')
        });
    };

    $scope.readDgfe = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_READ_DGFE'),
        operationFn: async () => {
            const result = await FiscalPrinters.readDgfe({ id: $scope.printer.id });
            dgfeResult.show(null, null, result);
        }
    });

    $scope.readDgfeBetween = async () => {
        if ($scope.dgfe.from > $scope.dgfe.to) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.DATE_ERROR'));
            return;
        }

        await executeFiscalOperation({
            confirmMessage: $translate.instant('PRINTERS.DETAIL.WANT_TO_READ_DGFE'),
            operationFn: async () => {
                const result = await FiscalPrinters.readDgfeBetween(
                    { id: $scope.printer.id },
                    convertDateToDDMMYY($scope.dgfe.from),
                    convertDateToDDMMYY($scope.dgfe.to)
                );
                dgfeResult.show($scope.dgfe.from.toLocaleDateString(), $scope.dgfe.to.toLocaleDateString(), result);
            }
        });
    };

    $scope.printDgfe = () => executeFiscalOperation({
        confirmMessage: $translate.instant('PRINTERS.DETAIL.PRINT_ALL_DGFE'),
        operationFn: () => FiscalPrinters.printDgfe({ printer: { id: $scope.printer.id } }),
        successMessage: $translate.instant('PRINTERS.DETAIL.DGFE_PRINTED')
    });

    $scope.printDgfeBetween = async () => {
        if ($scope.dgfe.from > $scope.dgfe.to) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.DATE_ERROR'));
            return;
        }

        await executeFiscalOperation({
            confirmMessage: $translate.instant('PRINTERS.DETAIL.PRINT_DGFE'),
            operationFn: () => FiscalPrinters.printDgfeBetween(
                { printer: { id: $scope.printer.id } },
                convertDateToDDMMYY($scope.dgfe.from),
                convertDateToDDMMYY($scope.dgfe.to)
            ),
            successMessage: $translate.instant('PRINTERS.DETAIL.PRINT_COMPLETED')
        });
    };

    $scope.saveDgfe = async () => {
        if (environmentInfo.isMobileApp()) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.SAVE_ONLY_ON_BROWSERS'));
            return;
        }

        await executeFiscalOperation({
            confirmMessage: $translate.instant('PRINTERS.DETAIL.SAVE_DGFE'),
            operationFn: async () => {
                const result = await FiscalPrinters.readDgfe({ id: $scope.printer.id });
                const file = new Blob([result], { type: 'text/plain' });
                $scope.downloadAllLink = (window.URL || window.webkitURL).createObjectURL(file);
            }
        });
    };

    $scope.saveDgfeBetween = async () => {
        if (environmentInfo.isMobileApp()) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.SAVE_ONLY_ON_BROWSERS'));
            return;
        }

        if ($scope.dgfe.from > $scope.dgfe.to) {
            alertDialog.show($translate.instant('PRINTERS.DETAIL.DATE_ERROR'));
            return;
        }

        await executeFiscalOperation({
            confirmMessage: $translate.instant('PRINTERS.DETAIL.PRINT_DGFE'),
            operationFn: async () => {
                const result = await FiscalPrinters.readDgfeBetween(
                    { id: $scope.printer.id },
                    convertDateToDDMMYY($scope.dgfe.from),
                    convertDateToDDMMYY($scope.dgfe.to)
                );

                const file = new Blob([result], { type: 'text/plain' });
                $scope.downloadSelectionLink = (window.URL || window.webkitURL).createObjectURL(file);
            }
        });
    };

    const convertDateToDDMMYY = (date) => $filter('sclDate')(date, 'DDMMYY');

    const preparePrinterForSave = () => {
        const printerClone = structuredClone($scope.printer);

        // 1. Categories cleanup: keep only those to be printed and remove the 'toPrint' flag
        printerClone.categories = (printerClone.categories || [])
            .filter(c => c.toPrint)
            .map(({ toPrint, ...category }) => category);

        const { type } = printerClone;

        // 2. Non-Fiscal configuration management
        if (type === 'nonfiscal') {
            Object.assign($scope.printerConfiguration, {
                cashregisters: $scope.cashregisters.filter(p => p._enabled).map(p => p.id),
                other_printers: $scope.otherPrinters.filter(p => p._enabled).map(({ id, inline }) => ({ id, inline })),
                rooms: printerClone._noRooms ? [] : $scope.rooms.filter(r => r._enabled).map(r => r.id),
            });
        }

        // 3. Empty IP addresses cleanup for physical/specific types
        const physicalTypes = ['fiscal', 'receipt', 'rt', 'kds'];

        if (physicalTypes.includes(type)) {
            ['ip_address', 'subnet_mask', 'gateway'].forEach(key => {
                if (printerClone[key] === "") {
                    printerClone[key] = null;
                }
            });
        }

        // 4. Configuration serialization if required by the type
        const { header_font_size_1, ...cleanConfig } = $scope.printerConfiguration || {};

        printerClone.configuration = Object.keys(cleanConfig).length
            ? JSON.stringify(cleanConfig)
            : null;

        return printerClone;
    };

    const getSaveButtonConfig = (tabName) => {
        switch (tabName) {
            case 'operations':
                // fiscal
                return {
                    label: '',
                    action: undefined,
                    enabled: () => false
                };
            case 'categories':
            case 'otherPrinters':
            case 'rooms':
            case 'cashregisters':
                // nonfiscal
                return {
                    label: $translate.instant('PRINTERS.DETAIL.SAVE'),
                    action: $scope.savePrinter,
                    enabled: () => true
                };
            case 'settings':
                if (['fiscal', 'rt'].includes($scope.printer.type)) {
                    return {
                        label: $translate.instant('PRINTERS.DETAIL.SAVE'),
                        action: $scope.savePrinter,
                        enabled: () => $scope.settingsForm.$valid
                    };
                } else {
                    return {
                        label: $translate.instant('PRINTERS.DETAIL.SAVE'),
                        action: $scope.savePrinter,
                        enabled: () => $scope.settingsForm.$valid
                    };
                }
            break;
            case 'documents':
                // fiscal
                return {
                    label: $translate.instant('PRINTERS.DETAIL.SAVE'),
                    action: $scope.savePrinter,
                    enabled: () => true
                };
            case 'configuration':
                // fiscal
                return {
                    label: $translate.instant('PRINTERS.DETAIL.CONFIGURE'),
                    action: $scope.configure,
                    enabled: () => !$scope.configuringPrinter
                };
            default:
            break;
        }
    };

    $scope.onTabLeave = async(sectionName) => {
        const targetForm = $scope[`${sectionName}Form`];

        if(!targetForm?.$dirty) {
            return;
        }

        try {
            const proceed = await confirmDialog.show($translate.instant('PRINTERS.DETAIL.CONTINUE_WITHOUT_SAVE'));

            if (!proceed) {
                throw true;
            }

            // restore printer
            $scope.printer = structuredClone(printer);

            if (['nonfiscal', 'receipt'].includes(printer.type)) {
                parseNonFiscalConfiguration();
            }

            // restore categories to be visualized
            parsePrinterCategories();

            targetForm?.$setPristine();
        } catch(err) {
            $scope.selectedTab = sectionName;
        }
    };

    $scope.openTab = async (tabName) => {
        $scope.selectedTab = tabName;

        if($scope.$parent) {
            $scope.$parent.configured_at = $scope.printer.configured_at ? moment($scope.printer.configured_at).format("DD/MM/YYYY HH:mm") : null;
            $scope.$parent.topbar_context.saveButton = getSaveButtonConfig(tabName);
        }
    };

    $scope.$parent.topbar_context.unsaved = () => ($scope.categoriesForm?.$dirty || $scope.settingsForm?.$dirty || $scope.documentsForm?.$dirty);

    if (!printer) {
        $state.go('app.printers.general', {}, {
            reload: "app.printers"
        });
    } else {
        parsePrinterConfiguration();
    }

    $scope.$parent.hidePrintersLoader();
}
